import { jsx as n } from "react/jsx-runtime";
function e(t) {
  const o = t.width || "16", h = t.height || "16";
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: o,
      height: h,
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...t,
      children: /* @__PURE__ */ n("path", { d: "M1.99329 4.92094C1.66662 5.2476 1.66662 5.77427 1.99329 6.10094L7.53329 11.6409C7.79329 11.9009 8.21329 11.9009 8.47329 11.6409L14.0133 6.10094C14.34 5.77427 14.34 5.2476 14.0133 4.92094C13.6866 4.59427 13.16 4.59427 12.8333 4.92094L7.99996 9.7476L3.16662 4.91427C2.84662 4.59427 2.31329 4.59427 1.99329 4.92094Z" })
    }
  );
}
export {
  e as A
};
